import { render, staticRenderFns } from "./StatsPhoenixGeoDetails.vue?vue&type=template&id=5f992ee7&"
import script from "./StatsPhoenixGeoDetails.vue?vue&type=script&lang=js&"
export * from "./StatsPhoenixGeoDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatsPhoenixGeoDetails.vue?vue&type=style&index=0&id=5f992ee7&prod&lang=scss&"
import style1 from "./StatsPhoenixGeoDetails.vue?vue&type=style&index=1&id=5f992ee7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports